import * as inputRules from './src/inputRuleConfig'

export * from './src/config'
export * from './src/language'
export * from './src/types'
export * from './src/ui'
export * from './src/util'

export const inputRuleConfig = inputRules
